import { checkIsAdminRole } from '@/modules'
import { useSelector } from 'react-redux'

/**
 * Checks logged in user role if it includes owner or admin
 * @returns boolean
 */
const useCheckIsAdminRole = () => {
  const userInfo = useSelector(state => state.user.info)
  return checkIsAdminRole(userInfo)
}

export default useCheckIsAdminRole
